import React, { useCallback, useRef } from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import { withTranslation } from "react-i18next";
import { useGetContractTemplateList } from "repositories/contract-repository";
import constants from "../../../../../constants";
import { decodeId, getCacheLocalstorage } from "utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Empty from "components/Empty";
import styles from "./MultiStep.module.scss"
function SavedTemplateSelectionModal({
  t,
  isOpen,
  closeStepOneModal,
  fetchAndSetTemplateData,
  designationType,
  selectedTemplateId,
}) {
  const values = getCacheLocalstorage(
    constants.contracts.contractslocalstorageKey,
    true
  );
  const params = useParams();
  const officeId = params.officeId ? decodeId(params.officeId) : 0;
  const { data: templateLists, isLoading } = useGetContractTemplateList(
    {
      officeId,
      isSavedTemplate: true,
      templateType: +designationType,
      OwnerId: values?.ownerId,
    },
    {
      enabled: !!officeId && !!values?.ownerId,
    }
  );

  const templateRef = useRef(selectedTemplateId || null);
  const handleSelectUser = useCallback((templateId) => {
    templateRef.current = templateId;
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => closeStepOneModal(false)}
      className="modal-dialog-centered modal-width-660 new-group-modal"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => closeStepOneModal(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        {/* Header */}
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          {t("contracts.selectATemplate")}
        </Text>

        {/* Loading indicator */}
        {isLoading ? (
          <div className="loader-container text-center">
            <Spinner animation="border" className="loader-spinner" />
          </div>
        ) : (
          <>
            {/* Member list */}
            <ul className="modal-employee-list group-list" id="scrollableDiv">
              {templateLists?.length > 0 ? (
                templateLists.map((item) => {
                  return (
                    <li key={item?.id}>
                      <div className={`ch-radio template-radio`}>
                        <label>
                          <input
                            type="radio"
                            name="template_id"
                            defaultChecked={selectedTemplateId?.id === item?.id}
                            onChange={() => handleSelectUser(item)}
                          />
                          <span className={styles["span-checked"]}>{item?.name || ""}</span>
                        </label>
                      </div>
                    </li>
                  );
                })
              ) : (
                <li>
                  <Empty Message={t("contracts.noTemplateAvailable")}/>
                </li>
              )}
            </ul>
          </>
        )}
        {/* Footer buttons */}
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100 mt-4"
          title={t("accountOwner.addEmployees")}
          onClick={() => fetchAndSetTemplateData(templateRef.current)}
        >
          {t("staff.select")}
        </button>
        <button
          className="button button-round button-border btn-mobile-link button-dark mb-md-3  mt-md-4"
          onClick={() => closeStepOneModal(false)}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(SavedTemplateSelectionModal);
